<router-outlet (activate)="onActivate($event)"></router-outlet>
<div class="api-loader-div" *ngIf="globalService.showApiLoader">
    <img src="assets/images/loader.gif">
</div>